import React, { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ROUTES, { HOME_INSURANCE_ROUTES_REGEX } from "../../constants/routes";
import LoadingOverlay from "../../components/LoadingOverlay";
import { PARTNER_TYPE } from "../../constants/datalayer";
import HomeInsuranceRoutes from "../home-insurance/home-insurance.routes";

export default function AppRoutes() {
    return (
        <Suspense fallback={<LoadingOverlay />}>
            <Switch>
                <Route
                    path={HOME_INSURANCE_ROUTES_REGEX}
                    render={props => (
                        <HomeInsuranceRoutes
                            {...props}
                            partner={PARTNER_TYPE.default}
                            partnerType={PARTNER_TYPE.default}
                        />
                    )}
                />
                <Route
                    path="/empresas/:partner/"
                    render={props => (
                        <HomeInsuranceRoutes
                            {...props}
                            partner={props.match.params.partner}
                            partnerType={PARTNER_TYPE.company}
                        />
                    )}
                />

                <Route
                    path="/:partner"
                    render={props => (
                        <HomeInsuranceRoutes
                            {...props}
                            partner={props.match.params.partner}
                            partnerType={PARTNER_TYPE.client}
                        />
                    )}
                />

                <Redirect to={ROUTES.HOME_INSURANCE._MAIN} />
            </Switch>
        </Suspense>
    );
}
